import React from "react";
import MainSection from "../components/MainSection";
import ServicesContentContainer from "../components/ServicesContentContainer";

const Payment = () => {
  const contentData = [
    {
      id: 1,
      title: "Understanding Your Financial Needs",
      description:
        "We start with understanding your financial needs and specific circumstances related to your international education fees. Our experts provide personalized advice to suit your requirements.",
    },
    {
      id: 2,
      title: "Competitive Exchange Rates",
      description:
        "We offer competitive exchange rates through our affiliated currency exchange company. This can lead to significant savings, especially for large amounts such as tuition fees, accommodation fees or living expenses.",
    },
    {
      id: 3,
      title: "Secure Payment Solutions",
      description:
        "We provide secure payment solutions for your international education fees. We ensure your funds reach the intended recipient safely and securely.",
    },
    {
      id: 4,
      title: "Guidance on Cost-Effective Methods",
      description:
        "We provide guidance on the most cost-effective methods to transfer funds internationally. Our aim is to help you save money and minimize fees associated with international transactions.",
    },
    {
      id: 5,
      title: "Navigating International Transactions",
      description:
        "International transactions can be complex. Our experts help you navigate these complexities, providing guidance at every step to ensure a smooth transaction process.",
    },
  ];

  const conclusion =
    "By taking advantage of our currency exchange and payment services, you can maximize the value of your investment in your education abroad. We are committed to providing efficient, secure, and cost-effective financial solutions for our students.";
  return (
    <>
      <MainSection bannerTxt="PAYMENT SERVICES" color="gray" />
      <ServicesContentContainer
        contentData={contentData}
        conclusion={conclusion}
        title={"Payment & Currency Exchange Services"}
        includeTxt={"Processes"}
      />
    </>
  );
};

export default Payment;
